module.exports = __webpack_public_path__ + "img/08a77f0.jpg";